import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_055.jpg';
page.images = [
  {
    imageId: 'page055_zoom0',
    rectangle: {
      x: 91 + 210,
      y: 57,
      width: 1620,
      height: 2440,
    },
    imageSrc: 'images/page054/054.jpg',
  },
];

export default page;
